import { render } from "./PokemonPicture.vue?vue&type=template&id=5b9076d8&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=5b9076d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\Cursos\\11 Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b9076d8"]])

export default __exports__